import React, { useCallback } from 'react';
import type { ReactNode } from 'react';
import { usePayment } from '../context';
import { CheckmarkSvg } from '@tectonics/features/jornada-sem-redirecionamento/pix-enrollment/screens/success-screen';
import { isSafeUrl } from '@tectonics/utils/url';
import {
  Container,
  Content,
  CheckmarkIcon,
  Title,
  Subtitle,
  ReturnButton,
} from './success-screen.styles';

export function SuccessScreen(): ReactNode {
  const { data } = usePayment();
  const redirectUrl = data.redirectUrlAfterPayment;
  const hasRedirect = redirectUrl && isSafeUrl(redirectUrl);

  const handleReturnToStore = useCallback(() => {
    if (hasRedirect && redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [hasRedirect, redirectUrl]);

  return (
    <Container>
      <Content>
        <CheckmarkIcon>
          <CheckmarkSvg />
        </CheckmarkIcon>

        <Title>Pagamento realizado com sucesso!</Title>
        {hasRedirect ? (
          <Subtitle>
            Volte à loja para acompanhar sua compra.
          </Subtitle>
        ) : null}

        {hasRedirect ? (
          <ReturnButton onClick={handleReturnToStore}>
            Voltar à loja
          </ReturnButton>
        ) : null}
      </Content>
    </Container>
  );
}
